import React, { useState, useEffect, useContext } from "react";
import "../styles/filing.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import DynamicIcon from "../components/dynamicicon";
import Case_Search from "../components/core/case_search";

import JisButton from "../components/controls/jisButton";
import FlowItem from "../components/controls/flowitem";
import { ShareContext } from "../context/ShareContext";

import * as Constants from "../constants";
import JisDialog from "../components/dialog";
import Gazette from "../components/core/gazette";
import BackLoader from "../components/backloader";
import Payment from "../components/core/payment";
import JisYesNo from "../components/controls/jisYesNo";
import JisDialogForm from "../components/formdialog";

function FilingMotion() {
  const FeeTYPEID = 31;
  const navigate = useNavigate();
  const { caseid } = useParams();

  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cinfo, setCase] = useState(null);
  const [flow, setFlow] = useState({ pos: 0, code: "motion_details" });
  const [flowerror, setFlowError] = useState("");
  const [casefeeId, setcasefeeId] = useState(null);
  const [parties, setParties] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [motionids, setmotionIds] = useState(""); // this is to store all motions id from this flow
  const [motions, setMotions] = useState([]);
  const [motion, setMotion] = useState([]);
  const [motionPrayers, setPrayers] = useState([{ prayer: "" }]);
  const [removingIndex, setRemovingIndex] = useState(null);
  const [isNonService, setIsNonService] = useState(false);
  const [isService, setIsService] = useState(false);
  const [isRelist, setIsRelist] = useState(false);
  const [isSetAside, setIsSetAside] = useState(false);

  const [previewPrayer, setPreviewPrayer] = useState(null);

  const onGazetteProceed = (e) => {
    console.log("after processing... here is value");
    console.log(e);
    setcasefeeId(e.feeid);
    setIsSuccess(e.isPaid);
    if (!e.isPaid) {
      on_gazette();
    }
  };
  const on_gazette = () => {
    setFlow({ pos: 2, code: "payment" });
  };
  const on_payment_back = () => setFlow({ pos: 1, code: "gazette" });

  useEffect(() => {
    if (caseid != null) {
      onLoad(caseid);
      onLoadServiceStatus(caseid); // for the service
    }
  }, [caseid]);
  const onLoad = async (_caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/mini-case-details/${_caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCase(data.caseinfo);

        setParties(data.parties.filter((c) => c.legalCounselId == profile.id));
        setIsLoaded(true);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadServiceStatus = async (_caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-services-status/${_caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setIsNonService(data.isNonService);
        setIsService(data.isService);
        setIsRelist(data.isRelist);
        setIsSetAside(data.isSetAside);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onSaveMotion = (e) => {
    e.preventDefault();
    // setParties({...parties,party});
    setMotions((prev) => [...prev, { ...motion, motionPrayers }]);
    setMotion({ partyId: "", motionClassificationId: "", motionTypeId: "" });
    setPrayers([{ prayer: "" }]);
  };

  const onChangePrayer = (index, key, value) => {
    setPrayers((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
    );
  };

  const onRemovePrayer = async (index) => {
    if (motionPrayers.length == 1) {
      return;
    }
    const h = motionPrayers[index];
    if (h && h.id > 0) {
      await onRemovePrayer_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setPrayers((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };
  const onRemovePrayer_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-prayer/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onAddPrayer = () => {
    setPrayers((prev) => [...prev, { prayer: "" }]);
  };

  const onMotionChange = (e) => {
    setMotion({ ...motion, [e.target.name]: e.target.value });
  };

  const onRemoveMotion_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-motion/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onRemoveMotion = async (index) => {
    const h = motionPrayers[index];
    if (h && h.id > 0) {
      await onRemoveMotion_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setMotions((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };

  const onEditMotion = (row, index) => {
    setRemovingIndex(index);
    setTimeout(() => {
      setMotions((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration

    //remove that one and allow it to be edited
    setMotion(row);
    setPrayers(row.motionPrayers);
  };
  const on_motions = async () => {
    if (motions.length == 0) {
      setFlowError("Please save the motion before continuing.");
      return;
    }
    setLoading(true);

    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Motion/${caseid}`, {
        method: "POST",
        body: JSON.stringify(motions),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        //setGazettes(data.gazettes);
        setmotionIds(data.motionids);
        setFlow({ pos: 2, code: "gazette" });
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onGotoDetails = () => {
    setIsSuccess(false);
    navigate(`/document-upload/${casefeeId}`); //navigate to login
  };
  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo?.caseNumber}</h3>
      </div>
      <div className="multiform">
        <div className="flow">
          <div className="itemgroup">
            <FlowItem
              flow={flow}
              pos={0}
              code="motion_details"
              title="Motion Details"
            />
            <FlowItem flow={flow} pos={1} code="gazette" title="Gazette" />
            <FlowItem
              flow={flow}
              pos={2}
              code="payment"
              title="Payment"
              isLast={true}
            />
          </div>
        </div>
        {flow.code == "motion_details" && (
          <div className="view">
            <div className="view">
              <div className="motion-details-form-wrapper">
                <form onSubmit={onSaveMotion}>
                  <div>
                    <div className="select-group">
                      <label>Select Party </label>
                      <select
                        name="partyId"
                        value={motion.partyId}
                        required
                        onChange={onMotionChange}
                      >
                        <option value="">Select </option>
                        {parties
                          //?.filter(opt => opt.partyTypeId == Constants.ClaimantType)
                          .map((opt, index) => (
                            <option key={index} value={opt.id}>
                              {opt.firstName} {opt.lastName ?? ""}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="form-section">
                      <div className="select-group">
                        <label> Motion/Application classification </label>
                        <select
                          name="motionClassificationId"
                          value={motion.motionClassificationId}
                          required
                          onChange={onMotionChange}
                        >
                          <option value="">Select </option>
                          {frequentData?.motionclass?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="select-group">
                        <label> Motion/Application Type </label>
                        <select
                          name="motionTypeId"
                          value={motion.motionTypeId}
                          required
                          onChange={onMotionChange}
                        >
                          <option value="">Select </option>
                          {frequentData?.motiontypes
                            ?.filter(
                              (e) => e.filingTypeId == cinfo?.caseFilingId,
                            )
                            .map(
                              (opt) =>
                                ((opt.id == 14 && isNonService) ||
                                  (opt.id == 15 && isService) ||
                                  (opt.id == 17 && isRelist) ||
                                  (opt.id == 18 && isSetAside) ||
                                  (opt.id != 14 &&
                                    opt.id != 15 &&
                                    opt.id != 17 &&
                                    opt.id != 18)) && (
                                  <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                  </option>
                                ),
                            )}
                        </select>
                      </div>
                    </div>

                    <div>
                      {motionPrayers?.map((pray, index) => (
                        <div
                          key={index}
                          className={`claim-item ${
                            removingIndex === index ? "removing" : ""
                          }`}
                        >
                          <div>
                            <div className="input-group">
                              <label className="input-group-label ">
                                Particulars of Prayers Sought{" "}
                              </label>
                              <div className="input-wrapper">
                                <textarea
                                  placeholder=" Particulars of Prayers Sought"
                                  required={true}
                                  value={pray.prayer}
                                  className="input-group-textarea"
                                  onChange={(e) =>
                                    onChangePrayer(
                                      index,
                                      "prayer",
                                      e.target.value,
                                    )
                                  }
                                />
                                <div
                                  className="delete"
                                  onClick={() => onRemovePrayer(index)}
                                >
                                  <DynamicIcon iname="trash-2" size={24} />{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className=" form-section--actions">
                      <button
                        icon="add"
                        variant="outline"
                        onClick={onAddPrayer}
                        type="button"
                        className="add-prayer-button action-buttons"
                      >
                        Add More Prayer
                      </button>
                      <button
                        className="save-motion-button action-buttons"
                        type="submit"
                      >
                        Save Motion
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="flowerror">{flowerror}</div>
              <div className="flowbuttongroup">
                <button
                  className="exhibit-button "
                  type="submit"
                  style={{ paddingBottom: "24px" }}
                  onClick={on_motions}
                >
                  Continue
                </button>
              </div>

              {motions.length > 0 && (
                <div className="saved-motion-container">
                  <div className="table-header">
                    <p>Saved Motion </p>
                  </div>
                  <div className="table-wrapper">
                    <table class="case-details-table full-border">
                      <tr>
                        <th>Party</th>
                        <th className="col-medium">Application Type</th>
                        <th className="col-title">Application Classification</th>
                        <th className="col-title">Prayers</th>
                        <th className="col-action">Edit</th>
                        <th className="col-action">Remove</th>
                      </tr>
                      {motions?.map((opt, index) => (
                        <tr key={index}>
                          <td>
                            {Constants.getItemById(parties, opt.partyId)
                              ?.firstName ||
                            Constants.getItemById(parties, opt.partyId)
                              ?.lastName
                              ? `${
                                  Constants.getItemById(parties, opt.partyId)
                                    ?.firstName
                                } ${
                                  Constants.getItemById(parties, opt.partyId)
                                    ?.lastName ?? ""
                                }`
                              : "N/A"}
                            {/* {
                              Constants.getItemById(parties, opt.partyId)
                                ?.firstName
                            }{" "}
                            {Constants.getItemById(parties, opt.partyId)
                              ?.lastName ?? ""} */}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData.motionclass,
                              opt.motionClassificationId,
                            )?.title || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData.motiontypes,
                              opt.motionTypeId,
                            )?.title || "N/A"}
                          </td>
                          <td>
                            <button
                              onClick={() => setPreviewPrayer(opt)}
                              className="selected"
                            >
                              View prayer
                            </button>
                            {/* <ol>
                              {opt.motionPrayers?.map((pray, ind) => (
                                <li key={ind}>{pray.prayer}</li>
                              )) || "N/A"}
                            </ol> */}
                          </td>

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onEditMotion(opt, index)}
                            >
                              <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.2603 3.59924L5.05034 12.2892C4.74034 12.6192 4.44034 13.2692 4.38034 13.7192L4.01034 16.9592C3.88034 18.1292 4.72034 18.9292 5.88034 18.7292L9.10034 18.1792C9.55034 18.0992 10.1803 17.7692 10.4903 17.4292L18.7003 8.73924C20.1203 7.23924 20.7603 5.52924 18.5503 3.43924C16.3503 1.36924 14.6803 2.09924 13.2603 3.59924Z"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit={10}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M11.8896 5.05078C12.3196 7.81078 14.5596 9.92078 17.3396 10.2008"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit={10}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3 22H21"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit={10}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </JisButton>
                          </td>

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onRemoveMotion(index)}
                            >
                              <>
                                <svg
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                    stroke="#FF2E3B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                    stroke="#FF2E3B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                    stroke="#FF2E3B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M10.3301 16.5H13.6601"
                                    stroke="#FF2E3B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M9.5 12.5H14.5"
                                    stroke="#FF2E3B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </>
                            </JisButton>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {flow.code == "gazette" && (
          <div className="view">
            <Gazette
              filingtypeid={cinfo?.caseFilingId}
              levelid={cinfo?.caseCategoryId}
              feetypeid={FeeTYPEID}
              token={token}
              onProceed={(e) => onGazetteProceed(e)}
              caseid={cinfo?.caseId}
              feeId={casefeeId}
              fillingsource="motion"
              sourceid={motionids}
            >
              <div className="top-nav">
                <div className="left-top">
                  <div className="top">
                    <h2>
                      {cinfo?.referenceNumber} |{" "}
                      {
                        Constants.getItemById(
                          frequentData.casecategories,
                          cinfo?.caseCategoryId,
                        )?.categoryTitle
                      }
                    </h2>
                  </div>
                  <p>Select items related to the motion that you are filing</p>
                </div>
                <p className="nav-status">Motion Filing /Specifications</p>
              </div>
            </Gazette>
          </div>
        )}
        {flow.code == "payment" && (
          <div className="view">
            <Payment feeid={casefeeId} token={token} />

            <div className="flowbuttongroup">
              <JisButton onClick={on_payment_back}>Back</JisButton>
            </div>
          </div>
        )}
      </div>

      {/* Prayer Preview Modal */}
      {previewPrayer && (
        <JisDialogForm
          title="Prayers"
          onClose={() => setPreviewPrayer(null)}
          minWidth="40%"
        >
          <div
            style={{
              maxWidth: "680px",
            }}
          >
            <ul style={{ gap: 10, display: "flex", flexDirection: "column" }}>
              {previewPrayer.motionPrayers?.map((pray, prayInd) => (
                <li
                  style={{
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                  key={pray.id}
                >
                  <span
                    style={{
                      marginRight: 8,
                    }}
                  >
                    {prayInd + 1}.
                  </span>
                  <span>{pray.prayer}</span>
                </li>
              ))}
            </ul>
          </div>
        </JisDialogForm>
      )}

      <BackLoader open={loading} />

      {isSuccess && (
        <JisDialog title="Case Created Successfully.">
          <div>
            This case is created successfully. Payment is not required. Please
            continue to upload document
          </div>
          <JisButton onClick={onGotoDetails}>Upload document</JisButton>
        </JisDialog>
      )}
    </div>
  );
}

export default FilingMotion;
